module.exports = __webpack_public_path__ + "img/mobile-calendar.e09e6534.svg";